export default __webpack_public_path__ + "static/media/south-dir-btn.7200dc99.png";